import { isEmpty } from 'lodash';

import { CalendarDate, isBefore, isWithinInterval, subtractCalendarDate, toCalendarDate, today } from './dateutils';
import { LeaseExtended } from './leaseutils';
import { Invoice } from './types';

export const doesLeaseRespectBalance = (lease: LeaseExtended, balance: number) =>
  Math.abs(lease.balance ?? 0) > balance;

export const doesLeaseRespectLatePayment = (
  lease: LeaseExtended,
  latePaymentInMonth: number,
  unpaidInvoicesOfClient: Invoice[] | null
) => {
  if (!unpaidInvoicesOfClient || isEmpty(unpaidInvoicesOfClient)) {
    return false;
  }
  const unpaidInvoicesOfLease = unpaidInvoicesOfClient.filter((invoice) => invoice.leaseId === lease.id);
  if (isEmpty(unpaidInvoicesOfLease)) {
    return false;
  }
  const oldestInvoice = unpaidInvoicesOfLease.reduce((result: null | Invoice, currentInvoice) => {
    if (!result || (currentInvoice.dueDate ?? currentInvoice.invoiceDate) < (result.dueDate ?? result.invoiceDate)) {
      return currentInvoice;
    }
    return result;
  }, null);
  if (!oldestInvoice) {
    return true;
  }
  const latePayment = subtractCalendarDate(today(), latePaymentInMonth, 'months');
  const referenceDate = toCalendarDate(oldestInvoice.dueDate ?? oldestInvoice.invoiceDate);
  return isBefore(referenceDate, latePayment);
};

export const leaseFinishedInPeriod = (lease: LeaseExtended, from: CalendarDate, to: CalendarDate) => {
  return isWithinInterval(toCalendarDate(lease.endDate), {
    start: from,
    end: to,
  });
};
